// extracted by mini-css-extract-plugin
export var contentBody = "_8z-9";
export var headerImage = "_8z-2";
export var imageButton = "_8z-7";
export var imageButtonIcon = "_8z-8";
export var imageHeader = "_8z-4";
export var imageHeaderText = "_8z-5";
export var imageOverlay = "_8z-3";
export var imageTitle = "_8z-6";
export var imageWrapper = "_8z-1";
export var taskList = "_8z-a";
export var widget = "_8z-0";